import { AxiosClient } from '@/app/shared/services';
import moment from 'moment';

const state = {
    checked_deals: [],
    isUpdating: false,
    filters: {
        id: "",
        user_id: "",
        offer_ids: [],
        payout: "",
        currency: "",
        statuses: [],
        date: { from: moment().format('YYYY-MM-DD'), to: moment().add(1, 'days').format('YYYY-MM-DD') },
        registerDate: { },
        aff_sub1: '',
        aff_sub2: '',
        aff_sub3: '',
        aff_sub5: '',
        email: "",
        phone: "",
        private_key: "",
        vkid: "",
        pxlid: "",
        utm_source: "",
        utm_medium: "",
        utm_campaign: "",
        utm_term: "",
        utm_content: "",
    },
    showFilters: {
        id: false,
        user_id: false,
        offer_ids: false,
        payout: false,
        currency: false,
        statuses: false,
        aff_sub1: false,
        aff_sub2: false,
        aff_sub3: false,
        aff_sub4: false,
        aff_sub5: false,
        vkid: false,
        pxlid: false,
        utm_source: false,
        utm_medium: false,
        utm_campaign: false,
        utm_term: false,
        utm_content: false,
        email: false,
        phone: false,
        registerDate: {
            from: false,
            to: false,
        },
    },
    modals: {
        dealsFilters: false,
    },
};

const getters = {
    GET_DEALS_FILTERS: (state)=> state.filters,
    POSTBACK_IS_UPDATING: (state) => state.isUpdating,
    GET_DEAL_SHOW_FILTERS: (state) => state.showFilters,
    GET_CHECKED_DEALS: (state) => state.checked_deals,
    IS_DEAL_FILTERS_MODAL_OPENED: (state) => state.modals.dealsFilters,
};

const mutations = {
    REFRESH_DEALS_FILTERS: (state) => {
        for (const key in state.filters) {
            if (state.filters[key] instanceof Array) {
                state.filters[key] = [];
                continue;
            }
            if (state.filters[key] instanceof Object) {
                state.filters[key] = {};
                continue;
            }
            if (typeof state.filters[key] === "number") {
                delete state.filters[key];
            }
            state.filters[key] = "";
        }
    },
    REFRESH_SHOW_FILTERS: (state) => {
        for (const key in state.showFilters) {
            if (state.showFilters[key] instanceof Object) {
                state.showFilters[key] = {};
                continue;
            }
            if (typeof state.showFilters[key] instanceof Boolean) {
                state.showFilters[key] = false;
                continue;
            }
            state.showFilters[key] = false;
        }
    },
    SET_DEALS_FILTERS_MODAL_IS_OPENED: (state, isOpen) => (state.modals.dealsFilters = isOpen),
    SET_CHECKED_DEALS: (state, rows) => (state.checked_deals = rows),
    SET_POSTBACK_SAVING: (state, isUpdating) => {
        state.isUpdating = isUpdating;
    },
};

const actions = {
  GET_DEALS: (context, params) => new Promise((resolve, reject) => {
    AxiosClient.get('/deals/get_deals', { params })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  UPDATE_POSTBACKS: (context, params) => new Promise((resolve, reject) => {
    context.commit("SET_POSTBACK_SAVING", true);
    AxiosClient.post('/offers/update_statistics', { params })
        .then((data) => {
            resolve(data);
        })
        .catch((error) => {
            reject(error);
        })
        .finally(() => {
            context.commit("SET_POSTBACK_SAVING", false);
            context.commit("SET_CHECKED_DEALS", []);
        });
  }),
  CHECKED_DEALS: (context, rows) => context.commit("SET_CHECKED_DEALS", rows),
  REFRESH_DEALS_FILTERS: (context) => context.commit("REFRESH_DEALS_FILTERS"),
  REFRESH_SHOW_FILTERS: (context) => context.commit("REFRESH_SHOW_FILTERS"),
  DEALS_FILTERS_MODAL: (context, isOpen) => {
      context.commit("SET_DEALS_FILTERS_MODAL_IS_OPENED", isOpen);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
